<template>
    <div class="loading">
        <div class="loader-svg">
            <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="20px"
                height="20px"
                viewBox="0 0 50 50"
                style="enable-background: new 0 0 50 50"
                xml:space="preserve"
            >
                <path
                    fill="#000"
                    d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                >
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="0.6s"
                        repeatCount="indefinite"
                    />
                </path>
            </svg>
        </div>
        {{ text || $t('loading') }}
    </div>
</template>

<script>
export default {
    name: 'loader',
    props: {
        text: {
            type: String,
        },
    },
    created() {
        this.handleI18n();
    },
    methods: {
        async handleI18n() {
            if (this.$i18n) {
                //only if i18n is initiated
                let currentLang = this.$i18n.locale;
                let messages = this.$i18n.messages;

                if (messages[currentLang] && !messages[currentLang].loading) {
                    //only load the current langauge and when not already added
                    const lang = require(`./../i18n/loader.${currentLang}.json`);
                    this.$i18n.setLocaleMessage(currentLang, {
                        ...messages[currentLang],
                        ...lang,
                    });
                }
            }
        },
    },
    i18n: {
        messages: {
            en: {
                loading: 'Loading',
            },
            fr: {
                loading: 'Chargement',
            },
            nl: {
                loading: 'Laden',
            },
        },
    },
};
</script>

<style lang="scss">
.loading {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 2rem;
    color: rgba(0, 0, 0, 0.6);
    margin: 15px 0;

    .loader-svg {
        height: 20px;
        width: 20px;
        display: inline-block;
        vertical-align: top;
    }

    svg path,
    svg rect {
        fill: rgba(0, 0, 0, 0.6);
    }
}
</style>
